<template></template>

<script lang="ts">
export default {}
</script>
